import FormControlLabel from '@mui/material/FormControlLabel';

import { RadioGroup, SliderField } from 'common/components/FormField';
import { Radio } from 'common/components/Radio';
import {
    EFilterType,
    IFilterFormItem,
    TRangeFilterValue,
    TStringFilterValue,
} from 'common/types';
import { getRangeFilterDisplay } from 'common/utils/filter';
import { translate } from 'utils/i18n';

export function skillComplianceFilter(
    transKey = 'groupSkillDrawer.filters'
): IFilterFormItem<TStringFilterValue> {
    return {
        key: 'compliance',
        label: translate(`${transKey}.compliance`),
        defaultExpanded: true,
        fields: [
            {
                name: 'compliance',
                type: EFilterType.Radio,
                initialValue: 'all',
                component: RadioGroup,
                componentProps: {
                    sx: { flexDirection: 'column', mt: -2 },
                    children: [
                        <FormControlLabel
                            control={<Radio color="primary" />}
                            key="all"
                            label={translate(`${transKey}.allOption`)}
                            value="all"
                        />,
                        <FormControlLabel
                            control={<Radio color="primary" />}
                            key="true"
                            label={translate(`${transKey}.compliantOption`)}
                            value="true"
                        />,
                        <FormControlLabel
                            control={<Radio color="primary" />}
                            key="false"
                            label={translate(`${transKey}.notCompliantOption`)}
                            value="false"
                        />,
                    ],
                },
                queryKey: 'isCompliant',
                chip: {
                    label: translate(`${transKey}.complianceChip`),
                    parseValue: (value) => {
                        if (value === 'true')
                            return translate(`${transKey}.compliantValue`);

                        return translate(`${transKey}.notCompliantValue`);
                    },
                },
                parseQueryValue: (value) => {
                    if (value === 'all') return;

                    return value === 'true';
                },
            },
        ],
    };
}

export function skillProgressFilter(
    transKey = 'reportFilters.progress'
): IFilterFormItem<TRangeFilterValue> {
    return {
        key: 'progress',
        label: translate(`${transKey}.sectionTitle`),
        defaultExpanded: true,
        fields: [
            {
                name: 'progress',
                type: EFilterType.Range,
                initialValue: [0, 1],
                component: SliderField,
                componentProps: {
                    min: 0,
                    max: 1,
                    step: 0.01,
                    valueLabelFormat: (value: string) =>
                        `${Math.floor(+value * 100)}%`,
                    marks: [
                        { value: 0, label: '0%' },
                        { value: 1, label: '100%' },
                    ],
                },
                chip: {
                    label: translate(`${transKey}.chip`),
                    parseValue: getRangeFilterDisplay,
                    appendValue: '%',
                },
            },
        ],
    };
}
